<template>
  <div class="apis-services q-py-lg">
    <dashboard-card
      v-if="user"
      icon="pause"
      color="deep-orange"
      title="Organization is Paused"
      class="q-mx-auto"
      style="max-width: 402px"
    >
      <div class="q-mb-md">
        This organization has been paused since
        <b>{{ format(parseISO(user.pausedOn), 'MM/dd/yyyy') }}</b
        >.
      </div>
      <div class="q-my-md">
        Please contact your Organization owner or the customer support team.
      </div>
      <template #footer>
        <div class="row justify-end">
          <q-btn color="deep-orange" no-caps flat label="Contact Support" @click="openIntercom" />
        </div>
      </template>
    </dashboard-card>
  </div>
</template>

<script lang="ts">
import { parseISO, format } from 'date-fns'
import DashboardCard from '@/components/DashboardCard.vue'

export default {
  name: 'OrganizationPaused',
  components: {
    DashboardCard
  },
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$auth0.user.value
    }
  },
  methods: {
    parseISO,
    format,
    openIntercom() {
      this.$tracker.openedIntercom()
      Intercom('show')
    }
  }
}
</script>
<style scoped>
.verify-email {
  max-width: 1280px;
  margin: auto;
}
</style>
